import { render } from "./ActionIcon.vue?vue&type=template&id=b6f84520&scoped=true"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"

import "./ActionIcon.vue?vue&type=style&index=0&id=b6f84520&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f84520"]])

export default __exports__